import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { API_URL } from "../../constants";
import { toast } from "react-toastify";
import BrandLogo from "../atoms/brandLogo";
import { numberFormat } from "../../utils";
import Download from "../../assets/images/Download.svg";
import axios from "axios";

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #000000b5;
  width: 100%;
  height: 100%;
  padding: 3em 0;
  z-index: 10;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 1px;
  }
`;
const Container = styled.div`
  margin-bottom: 4em;
  padding: 0.01em 0;
  border-radius: 0.375rem;
  width: 24.375rem;
  background: #fff;
  z-index: 500;
  top: 2em;
  margin: 0 auto;
  box-shadow: 0px 0px 7px 0px rgba(44, 44, 44, 0.493);
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 80%;
    /* top: 3em; */
  }
`;
const Logo = styled.div`
  width: 4.125em;
  height: 4.125em;
  border-radius: 50%;
  overflow: hidden;
  margin: 2em auto;
`;
const Card = styled.div`
  width: 90%;
  border-radius: 0.375rem;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(217, 217, 217, 0.25);
  margin: 2em auto;
  padding: 2em 1.7em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
  h1 {
    color: #3f3f3f;
  
    font-size: 1.1875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    width: 100%;
    padding: 2em auto;
  }
`;
const SubDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2em auto;
  align-items: baseline;
  h2 {
    color: #3f3f3f;
  
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
const Note = styled.div`
  margin: 2em auto;
  p {
    color: #3f3f3f;
  
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 0.5em 0;
  }
  h2 {
    color: #3f3f3f;
  
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
const Reward = styled.div`
  margin: 2em auto;
  color: #3f3f3f;

  font-size: 0.875em;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 120%;
  background: #ffedfd;
  padding: 0.2em 1.75em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    left: 50%;
    transform: translateX(-50%);

    width: 130%;
    padding: 0.62em 1.75em;
  }
  div {
    display: flex;
    justify-content: space-between;
    margin: 0.5em auto;
    align-items: baseline;
    h2 {
      color: #3f3f3f;
    
      font-size: 0.875em;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
`;

const Total = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 2em auto;
  h2 {
    color: #3f3f3f;
  
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;
const PaymentSubHeading = styled.h2`
  color: #3f3f3f;

  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
const Document = styled.div`
  width: 100%;
  display: flex;
  height: 2.25rem;
  justify-content: space-between;

  margin: 0.88em auto;
  align-items: center;

  cursor: pointer;
  border-radius: 0.25rem;
  border: 1px solid #efefef;
  background: #fff;
  padding: 0.6em 0.6em;
  p {
    color: #3f3f3f;
  
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  img {
    width: 1.125rem;
    height: 1.125rem;
  }
`;
const ConfirmButton = styled.button`
  width: 100%;
  height: 2.5rem;
  border-radius: 0.5rem;
  background: #000;
  color: #fff;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 2.5em auto;
  text-align: center;
  margin-bottom: 1.56em;
`;
const Reject = styled.button`
  justify-self: center;
  display: flex;
  color: #7d7d7d;
  font-family: Poppins;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin: 0 auto;
  margin-bottom: 3.56em;
`;

interface ProfileTabProps {
  toggleModal(): void;
  details: any;
  setisConfirmed: any;
  isConfirmed: boolean;
}
function TransactionRecieptModal({
  details,
  toggleModal,
  setisConfirmed,
  isConfirmed,
}: ProfileTabProps) {
  const uuid = useSelector((state: any) => state.auth.uuid);
  let [profile, setProfile] = useState<any>();

  const getProfile = async () => {
    const profile: any = await fetch(`${API_URL}/profile/${uuid}`).catch(
      (error) => {
        toast.error(error);
      }
    );
    if (profile) {
      let result = await profile.json();
      setProfile(result.data);
    }
  };

  useEffect(
    () => {
      getProfile();
    },
    // eslint-disable-next-line
    []
  );

  const handleConfirm = () => {
    axios
      .post(`${API_URL}/transaction/confirm`, {
        uuid: details.uuid,
        isPaid: true,
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success("Transaction Confirmed");
          toggleModal();

          setisConfirmed(!isConfirmed);
        }
      })
      .catch((error) => {
        setisConfirmed(!isConfirmed);
        // console.log(error)
        toast.error("Connection Failed");
      });
  };
  const handleReject = () => {
    axios
      .post(`${API_URL}/transaction/confirm`, {
        uuid: details.uuid,
        isPaid: false,
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success("Transaction Rejected");
          toggleModal();

          setisConfirmed(!isConfirmed);
        }
      })
      .catch((error) => {
        // console.log(error)

        setisConfirmed(!isConfirmed);
        toast.error("Connection Failed");
      });
  };

  const handleDownload = () => {
    // Replace 'your-pdf-file.pdf' with the actual path or URL of your PDF file.
    const downloadFile = details.receipt;
    // const blob = new Blob([downloadFile], { type: "application/pdf" });
    // const url = window.URL.createObjectURL(blob);

    // Create a link element and trigger a click event to download the file.
    const link = document.createElement("a");
    link.href = downloadFile;
    link.download = `spendbox-${details.number}`; // Specify the downloaded file name.
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <Modal onClick={() => toggleModal()}>
        <>
          <Container onClick={(event) => event.stopPropagation()}>
            <Logo>
              <BrandLogo src={profile?.image} />
            </Logo>
            <Card>
              <h1>Receipt</h1>
              <SubDiv>
                <h2>Subtotal Bill</h2>
                <p>{numberFormat(details.subtotal)}</p>
              </SubDiv>
              <SubDiv>
                <h2>From</h2>
                <p className="text-[0.875em]">{details.number}</p>
              </SubDiv>
              <Note>
                <h2>Note</h2>
                <p>{details?.description}</p>
              </Note>
              <Reward>
                <div>
                  <h2>Subtotal Bill</h2>
                  <p>{numberFormat(details.subtotal)}</p>
                </div>
                <div>
                  <h2>Reward</h2>
                  <p>-{numberFormat(details.reward)}</p>
                </div>
              </Reward>
              <Total>
                <h2>Total</h2>
                <h2>{numberFormat(details.total)}</h2>
              </Total>
              <PaymentSubHeading>Payment Reciept</PaymentSubHeading>
              <Document onClick={handleDownload}>
                <p>{details.reference}</p>
                <img src={Download} alt="download" />
              </Document>
              {details.status === "PENDING" && (
                <>
                  <ConfirmButton onClick={handleConfirm}>
                    Confirm Receipt
                  </ConfirmButton>
                  <Reject onClick={handleReject}>Reject and Delete</Reject>
                </>
              )}
            </Card>
          </Container>
        </>
      </Modal>
    </>
  );
}

export default TransactionRecieptModal;
